import { render } from "./symbolPagePriceBlock.vue?vue&type=template&id=b37746c0&scoped=true"
import script from "./symbolPagePriceBlock.vue?vue&type=script&lang=js"
export * from "./symbolPagePriceBlock.vue?vue&type=script&lang=js"

import "./symbolPagePriceBlock.vue?vue&type=style&index=0&id=b37746c0&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37746c0"]])

export default __exports__